import Vue from "vue";
import paginate from "vuejs-paginate";

Vue.component("Paginate", paginate);
